<div class="row">
  <div class="container-style">
    <div class="mb-1"><b>Visitas Pendientes del Cliente</b></div>
    <app-custom-table [headers]="header" [data]="data" [actions]="tableActions" (onAction)="onAction($event)"
      (onRecoverData)="getAllPendingVisitsWithPagination()" (onPageChange)="onPageChange($event)">
    </app-custom-table>
  </div>
</div>